import { SelectItemKey } from "vuetify";

export function FormatWithPrecision(quantity: number | null, precision: number = 1, removeZeros: boolean = true): string {
    if(quantity == null) return '';

    const rounded = quantity?.toFixed(precision);
    return removeZeros ? rounded?.replace(/[.]0+$/, '') ?? '' : rounded;
}

export function Pluralize(count: number, word: string | null, wordPlural: string | null): string {
    if (count === 1) {
        return word ?? '';
    } else return wordPlural ?? '';
}

export function GetNestedValue (obj: any, path: (string | number)[], fallback?: any): any {
    const last = path.length - 1

    if (last < 0) return obj === undefined ? fallback : obj

    for (let i = 0; i < last; i++) {
        if (obj == null) {
            return fallback
        }
        obj = obj[path[i]]
    }

    if (obj == null) return fallback

    return obj[path[last]] === undefined ? fallback : obj[path[last]]
}

export function GetObjectValueByPath (obj: any, path: string, fallback?: any): any {
    // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
    if (obj == null || !path || typeof path !== 'string') return fallback
    if (obj[path] !== undefined) return obj[path]
    path = path.replace(/\[(\w+)\]/g, '.$1') // convert indexes to properties
    path = path.replace(/^\./, '') // strip a leading dot
    return GetNestedValue(obj, path.split('.'), fallback)
}

export function GetPropertyFromItem (
    item: object,
    property: SelectItemKey,
    fallback?: any
): any {
    if (property == null) return item === undefined ? fallback : item

    if (item !== Object(item)) return fallback === undefined ? item : fallback

    if (typeof property === 'string') return GetObjectValueByPath(item, property, fallback)

    if (Array.isArray(property)) return GetNestedValue(item, property, fallback)

    if (typeof property !== 'function') return fallback

    const value = property(item, fallback)

    return typeof value === 'undefined' ? fallback : value
}

export function BlankStringToNull(value?: string | null): string | null {
    return value === '' ? null : value ?? null;
}

export function FindMostFrequentNumberOrDefault(arr: number[], defaultValue: number | null = null): number | null {
    return FindMostFrequentNumber(arr, defaultValue);
}

export function FindMostFrequentNumber(arr: number[], defaultValue: number | null = null, allowTies = false): number | null {
    const frequencyMap = arr.reduce((acc, num) => {
        acc[num] = (acc[num] || 0) + 1;
        return acc;
    }, {} as { [key: number]: number });

    const maxCount = Math.max(...Object.values(frequencyMap));

    // Find all numbers with the highest frequency
    const mostFrequentNumbers = Object.entries(frequencyMap)
        .filter(([_, count]) => count === maxCount)
        .map(([num]) => Number(num));

    // Return the result based on whether there's a clear mode
    if(allowTies)
        return mostFrequentNumbers[0] ?? defaultValue;

    return mostFrequentNumbers.length === 1 ? mostFrequentNumbers[0] : defaultValue;
}